export const types = {
  POPULATE_COUNTRIES_LIST: 'POPULATE_COUNTRIES_LIST',
};

export const populateCountriesList = (countries) => ({
  type: types.POPULATE_COUNTRIES_LIST,
  countries,
});



// WEBPACK FOOTER //
// ./redux/actions/countries.js